export default function mainSeoBlock() {
  const widgetName = 'mainSeoBlock';
  const widgetOpts = mainSeoBlockOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomMainSeo(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomMainSeo(widgetData) {
    const { Description } = widgetData.items[0];

    $widget.find('.card-widget-item').replaceWith(`<p>${Description}</p>`);
  }
}
